// extracted by mini-css-extract-plugin
export default {"container":"WhatsAppContainer_container__e+-HO","authWrapper":"WhatsAppContainer_authWrapper__YSTs8"};